export default __webpack_public_path__ + "97818760bfa221360975d712078e3325.png";